export const SUCCESS_LOGIN = 'auth/SUCCESS_LOGIN'
export const LOGOUT = 'auth/LOGOUT'